import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';

export default {
  namespaced: true,
  state: {
    plan: {},
    plans: [],
    plan_error: null,
    voucher_error: null,
    loading: false,
    subscriptions: [],
    invoices: [],
    busyVoucher: false,
    notSubscribed: false,
    voucher: {
      amount_off: 0
    }
  },
  mutations: {
    setPlan(state, plan) {
      state.plan = plan
    },
    setError(state, error) {
      state.plan_error = error
    },
    setVoucherError(state, error) {
      state.voucher_error = error
    },
    loading(state, payload) {
      state.loading = payload
    },
    setSubscriptions(state, payload) {
      state.subscriptions = payload
    },
    setInvoices(state, payload) {
      state.invoices = payload
    },
    busyVoucher(state, payload) {
      state.busyVoucher = payload
    },
    setVoucher(state, payload) {
      state.voucher = payload;
    },
    setNotSubscribed(state, payload) {
      state.notSubscribed = payload
    },
    setAllPlans(state, payload) {
      state.plans = payload.sort((a, b) => a.amount - b.amount)
    }
  },
  actions: {
    loadPlans({commit}) {
      // Load all the plans
      commit('loading', true);
      const getAllPlans = firebase.functions().httpsCallable('getAllPlans');
      return getAllPlans()
      .then((res) => { commit('setAllPlans', res.data.data); return res;})
      .finally(() => commit('loading', false));
    },
    loadSubscriptions({commit, rootState}) {      
      const id = rootState.Profile.profile.s
      commit('loading', true);

      // No subscriptions yet - just registered
      if (!id) {
        commit('setSubscriptions', []);
        commit('setNotSubscribed', true);
        commit('loading', false);
        return;
      }
      const getSubscriptions = firebase.functions().httpsCallable('getSubscriptions');
      return getSubscriptions({id: id})
      .then((res) => { commit('setSubscriptions', res.data.data); commit('setError', null)})
      .catch((e) => { commit('setError', { message: e.message, status: e.status }); throw e; })
      .finally(() => commit('loading', false));
    },
    loadInvoices({commit, rootState}) {
      const id = rootState.Profile.profile.s
      commit('loading', true);
      // No subscriptions yet - just registered
      if (!id) {
        commit('setInvoices', []);
        commit('loading', false);
        return;
      }
      const getInvoices = firebase.functions().httpsCallable('getInvoices');
      return getInvoices({id: id})
      .then((res) => { commit('setInvoices', res.data.data); commit('setError', null)})
      .catch((e) => { commit('setError', { message: e.message, status: e.status }); throw e; })
      .finally(() => commit('loading', false));
    },
    cancelSubscription({commit}, payload) {
      commit('loading', true);
      const cancelSubscription = firebase.functions().httpsCallable('cancelSubscription');
      return cancelSubscription({id: payload.id})
      .then(() => { commit('setError', null) })
      .catch((e) => { commit('setError', { message: e.message, status: e.status }); throw e; })
      .finally(() => commit('loading', false));
    },
    loadVoucher({commit}, payload) {
      commit('busyVoucher', true);
      const getVoucher = firebase.functions().httpsCallable('getVoucher');
      return getVoucher({id: payload})
      .then((res) => { commit('setVoucherError', null); commit('setVoucher', res.data) })
      .catch((e) => { commit('setVoucherError', { message: e.message, status: e.status });  commit('setVoucher', { amount_off: 0 }) ; throw e; })
      .finally(() => commit('busyVoucher', false));
    },

    // send({commit}, payload) {
    //   commit('is_sending', true);
    //   firebase.analytics().logEvent('generate_lead', { value: 'Contact Form' });
      
    //   var contactUs = firebase.functions().httpsCallable('contactUs');
    //   contactUs({
    //     emailAddress: payload.emailAddress,
    //     name: payload.name,
    //     subject: payload.subject,
    //     message: payload.message,
    //     subscribe: payload.subscribe
    //   })
    //   .then(data => {    
    //     commit('error_sending', null);
    //     commit('is_sending', false);
    //     commit('sent', true);
    //   })
    //   .catch(error => {
    //     commit('error_sending', error);
    //     commit('is_sending', false);
    //     commit('sent', false);
    //   })
    // }
  },
  getters: {
    // NOTE: Apparently getters are not getters/setter style and should be used for filtering only.
    //        Access properties directly from code instead.
    // is_sending(state) {
    //   return state.is_sending;
    // },
    // error_sending(state) {
    //   return state.error_sending
    // },
    // sent(state) {
    //   return state.sent
    // }
  }
}

export const types = {
  mutations: {
    // commit
    ERROR_SENDING: 'Message/error_sending',
  },
  actions: {
    // dispatch
    SEND_MESSAGE: 'Message/send'
  },
  getters: {
    IS_SENDING: 'Message/is_sending',
    SENT: 'Message/sent',
    ERROR_SENDING: 'Message/error_sending'
  }
}